import _Breadcrumb from './Breadcrumb';

import './style/index.js';

export type { BreadcrumbProps, BreadcrumbItemProps } from './BreadcrumbProps';
export * from './type';

export const Breadcrumb = _Breadcrumb;
export default Breadcrumb;
